<template>
  <vbt-dialog
    v-model="dialog"
    :title="title"
    :submit-btn-name="submitBtnName"
    @submit="submitForm"
    @close="resetFormValidation"
  >
    <v-text-field
      v-model.trim="form.name"
      :rules="validator.getRulesByField('name')"
      label="Name"
    />
    <v-text-field
      v-model.trim="form.abbreviation"
      :rules="validator.getRulesByField('abbreviation')"
      label="Abbreviation"
    />
    <v-text-field
      v-model.trim.number="form.thickness"
      :rules="validator.getRulesByField('thickness')"
      label="Thickness"
    />
  </vbt-dialog>
</template>

<script>
import { mapState } from 'vuex';

import { useDialog, useEditor, useFormWithRef } from '@mixins/factories';

import { Validator, wrapToLoadingFn } from '@helpers';

import { namespace as LocationsNamespace } from '@store/modules/locations.types';

import SubstratesApiService from '../_services/substrates.api.service';

import { generateSubstrateModel } from '../_models/substrate.model';

const validator = Validator.createValidator({
  name: ['required'],
  abbreviation: ['required'],
  thickness: ['required', 'number'],
});

export default {
  name: 'KernelSubstrateEditor',
  mixins: [
    useDialog(),
    useFormWithRef(),
    Validator.useValidator(validator),
    useEditor({ formGenerator: generateSubstrateModel }),
  ],
  computed: {
    ...mapState(LocationsNamespace, ['suffix']),
    title() {
      return this.creator ? 'Create substrate' : `Edit ${this.item.name}`;
    },
    action() {
      return this.creator
        ? SubstratesApiService.createSubstrate
        : SubstratesApiService.updateSubstrate;
    },
    submitPromptText() {
      return this.creator ? 'Create substrate?' : `Update substrate ${this.item.name}`;
    },
  },
  methods: {
    wrapToLoadingFn,
    submitForm() {
      if (!this.validateForm()) {
        return;
      }
      this.$VBlackerTheme.alert.warning({
        text: this.submitPromptText,
      }, () => this.wrapToLoadingFn({
        req: this.action.bind({}, {
          suffix: this.suffix,
          name: this.item.name,
          data: this.form,
        }),
        loadingSpinnerType: 'fullscreen',
        onSuccess: () => {
          this.$VBlackerTheme.notification.success(`Successfully ${
            this.creator ? 'created' : 'updated'
          }`);
          this.$emit('success');
          this.dialog = false;
        },
      }));
    },
  },
};
</script>
